// Helper to determine if we should skip axios request interceptors in storybook.
// This is used to prevent long delays in storybook due to waiting to grab the JWT token.
export const skipAxiosRequestInterceptors = (): boolean => {
  // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/no-explicit-any
  return typeof window !== 'undefined' && (window as any).__STORYBOOK_SKIP_AXIOS_INTERCEPTORS__;
};
